import { observable, action, computed } from 'mobx';
import { IAppAndBUIDConfigs, IServiceAppConfig, IServiceAppConfigs } from './IConfig';

export class Config {
    @observable public config: IServiceAppConfigs;

    constructor(appConfig: IServiceAppConfig) {
        this.updateConfig({ appConfig, buidConfig: {} });
    }

    @action
    public updateConfig(config: IAppAndBUIDConfigs) {
        this.config = {
            ...this.config,
            ...config?.appConfig,
            ...config?.buidConfig
        };
    }

    @computed
    public get languageId(): string {
        return this.config?.language?.id;
    }
}
